"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const stellarService_1 = require("./stellarService");
const axios_1 = __importDefault(require("axios"));
exports.checkVesting = (publicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const { server } = stellarService_1.getConfig();
    const accountsWhereIsSigner = (yield server.accounts().forSigner(publicKey).limit(200).call()).records;
    const accountsWhereIsSignerAndIsNotMe = accountsWhereIsSigner.filter(acc => acc.account_id !== publicKey);
    const accountRecord = accountsWhereIsSignerAndIsNotMe.find(acc => Object.keys(acc.data_attr).includes('tft-vesting'));
    if (!accountRecord) {
        return null;
    }
    const vestingAccount = yield server.loadAccount(accountRecord.account_id);
    if (vestingAccount.id !== accountRecord.account_id) {
        throw new Error('no vesting account found');
    }
    return vestingAccount;
});
exports.generateVestingAccount = (publicKey) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { serviceUrl } = stellarService_1.getConfig();
    let response;
    try {
        response = yield axios_1.default.post(`${serviceUrl}/vesting_service/create_vesting_account`, {
            owner_address: publicKey,
        });
    }
    catch (error) {
        throw new Error('Could not create vestingAccount');
    }
    const vestingAddress = (_a = response.data) === null || _a === void 0 ? void 0 : _a.address;
    if (!vestingAddress)
        throw new Error('Could not create vestingAccount');
    const { server } = stellarService_1.getConfig();
    const vestingAccount = yield server.loadAccount(vestingAddress);
    if (vestingAccount.id !== vestingAddress) {
        throw new Error('no vesting account found');
    }
    return vestingAccount;
});
//# sourceMappingURL=vestingService.js.map